import { doc, getDoc } from 'firebase/firestore';
import { FirestoreCollections, firestore } from '../../../firebase.config';
import { SubscriptionStatus } from '@leedpulse-monorepo/enums';

interface Subscription {
  id: string;
  name: string;
  idPlan: string;
  sender: string[];
  status: SubscriptionStatus;
}

async function getSubscriptionsByIds(
  subscriptionIds: string[]
): Promise<Subscription[]> {
  try {
    const db = firestore;
    const subscriptions: Subscription[] = [];

    for (const id of subscriptionIds) {
      const subscriptionDoc = await getDoc(
        doc(db, FirestoreCollections.subscriptions, id)
      );
      if (subscriptionDoc.exists()) {
        subscriptions.push({
          id,
          name: subscriptionDoc.data().name || 'Nom inconnu',
          idPlan: subscriptionDoc.data().id_plan || '',
          sender: subscriptionDoc.data().sender || [],
          status: subscriptionDoc.data().status as SubscriptionStatus,
        });
      }
    }

    return subscriptions;
  } catch (error) {
    console.error('Erreur lors de la récupération des abonnements :', error);
    return [];
  }
}

export default getSubscriptionsByIds;
// NOTE : Review this code as it has issues
// 1. It duplicates the getSubscriptions use case definition from the subscriptions domain
// 2. It  define a Subscription interface instead of using the correct entity and use the same name, causing confusion
// 3. If we want to create a simpler version of the getSubscriptions use case, we should call it getUserSubscriptions
// and return a true Subscription entity list (Subscription.fromFirestore is there to map Firestore data to a Subscription entity easily)
// 4. Also, instead of doing a for loop, we should use the getDocs function to get all the subscriptions at once
// using the where('id', 'in', subscriptionIds) query

